import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (dateStr: string | undefined): string => {
    if (!dateStr) {
        return 'Invalid date';
    }

    const parts = dateStr.split('-');
    if (parts.length !== 3) {
        return 'Invalid date format';
    }
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
};

export const formatDateToMonthYear = (dateStr: string | undefined): string => {
    if (!dateStr) {
        return 'Invalid date';
    }

    if (!dayjs(dateStr, 'YYYY-MM-DD', true).isValid()) {
        return 'Invalid date format';
    }

    return dayjs(dateStr).format('MMM YYYY');
};

export const formatReportingPeriod = (value: number): string => {
    return value === 1 ? `${value} year` : `${value} years`;
};

export const getMaximumAvailableReportingPeriod = (inceptionDate: string): number => {
    return dayjs().startOf('month').diff(dayjs(inceptionDate), 'years');
};

export const getPortfolioReportingPeriod = (funds: { inceptionDate: string }[]): number => {
    return funds.length ? Math.min(...funds.map(fund => getMaximumAvailableReportingPeriod(fund.inceptionDate))) : 4;
};

export const transformDMYToISODate = (date: string): string => {
    const dateParts = date.split('/');
    if (dateParts.length === 3) {
        return dateParts.reverse().join('-');
    }
    return date;
};

export const getReportingPeriod = (years: number) => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startOfCurrentMonth = dayjs().tz(userTimezone).startOf('month');

    const endDate = startOfCurrentMonth.subtract(1, 'days').format('YYYY-MM-DD');
    const startDate = startOfCurrentMonth.subtract(years, 'years').startOf('month').format('YYYY-MM-DD');

    return { startDate, endDate };
};

export const transformISOToDMYDate = (date: string | number) => {
    const value = String(date);
    const dateParts = value.split('-');
    if (dateParts.length === 3) {
        return dateParts.reverse().join('/');
    }
    return value;
};
